import { useLocation } from '@porterin/component-library/src/location-accuracy//contexts/LocationContext';
import React from 'react';

export const MapLocationLandmarkCmp: React.FC = ({}) => {
  const { state } = useLocation();

  return (
    <div
      className="text-[1.4rem] pt-6 pb-8 text-[#707582]"
      data-testid="map-landmark"
    >
      {state.address?.landmark}
    </div>
  );
};
